import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { LoaderService } from '../../loader/loader.service';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import * as jwt_decode from 'jwt-decode';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-ai-question',
  templateUrl: './ai-question.component.html',
  styleUrls: ['./ai-question.component.scss']
})
export class AiQuestionComponent implements OnInit, OnChanges {


  @Input() queryBlocks;
  @Input() transactionID: number = 0;
  @Input() sysPromptList: any[] = [];
  @Input() openAllAccordian;
  @Input() closeAllAccordian;
  @Input() documentsId: number = 0;
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;


  @Input() VectorDocumentID;
  @Input() pdfURL;
  @Input() pdfTextFromOCR;
  @Input() documentId;
  @Input() ocrTextFileUrl;
  @Output() sendDeletedQuery = new EventEmitter();
  @Output() sendsaveUpdateQuery = new EventEmitter();
  @Output() sendPageNumber = new EventEmitter();
  askQAquery: string;
  apiResponseTextArea: any;
  deletedQuery: any = [] = [];
  responseHolder: any = [] = [];
  organizationId: string;
  databaseId: string;
    isNta: boolean;
  isMedication: boolean;
  isAllergy: boolean;
  isCondition: boolean;
  isImmunization: boolean;
  isObservation: boolean;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) expansionPanel: QueryList<MatExpansionPanel>;
  openpanel: number;
  step = 0;
  currentAnswerChooseIndex: any;
  currentBlockToEdit: any;
  ddlsystemPromptID: number = 0;
  menuModulesList: any;
  CoreShowName: any;
  clickEventsubscriptionListSendMedications: any;

  //contect="Diagnosis: \n\n- Acidosis, unspecified\n- Dehydration sdsodowe\n- Hypotension, unspecified\n- Sepsis, unspecified organism\n- Syncope and collapse\n- Urinary tract infection, site not specified\n\nNTAs: \n\n- HIV/AIDS (B20)\n- Isolation (Z03.818)\n- Lupus, other connective tissue disorders, and inflammatory spondylopathies (M32.9)\n- Chronic Pancreatitis (K86.1)\n- Feeding tube while a resident\n- Malnutrition\n- Pressure ulcer stage 4 present\n- Ventilator or Respirator Post Admit\n- Parenteral IV Feeding Level Low\n\nICD-10 codes are not provided for some of the NTAs listed, but the ones that are provided are included above";

  constructor(private _dataSharingService: DataSharingService, private formsService: FormsService, private loaderService: LoaderService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private toastr: ToastrService,
    private dialog: MatDialog, private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    let SelectedCore = this.menuModulesList.filter((x) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    // this.clickEventsubscriptionListSendMedications = this._dataSharingService.getsaveMedicationToEntity().
    //  subscribe((result:any) => {
    //   if (result!="") {  
    //     this.transactionID=result;
    //     this.GetEmitTOSendMedication();
    //   }
    // });
    //this.contect= this.contect.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.openAllAccordian?.currentValue) {
      this.openAll();
    }
    if (changes.closeAllAccordian?.currentValue) {
      this.closeAll();
    }
  }


  openAll() {
    this.expansionPanel?.toArray().forEach((panel) => {
      panel.open();
    })
  }

  closeAll() {
    this.expansionPanel?.toArray().forEach((panel) => {
      panel.close();
    })
  }


  query_vector_db(index: number, block: any) {
    if (block.title == "" || block.title == null) {
      this.toastr.warning('Please add title.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.openpanel = index;
    this.loaderService.show();
    this.formsService.query_vector_db(block.askQAquery, this.VectorDocumentID)
      .subscribe(
        response => {
          if (response.success) {
            this.loaderService.hide();
            this.queryBlocks[index].apiResponseTextArea = response.response;
          } else {
            this.loaderService.hide();
            //console.error('Error querying vector DB', response.message);
          }
        },
        error => {
          this.loaderService.hide();
          //console.error('Error querying vector DB', error.message);
        }
      );
  }

  // deleteQuery(block,removeIndex){
  //   this.deletedQuery.push(block);
  //   if (removeIndex !== -1) this.queryBlocks.splice(removeIndex, 1); 
  //    this.sendDeletedQuery.emit(this.deletedQuery);
  //  }

  // For Delete Ask query
  deleteQuery(block, removeIndex) {
    this.deletedQuery = [];
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.deletedQuery.push(block);
        if (removeIndex !== -1) this.queryBlocks.splice(removeIndex, 1);
        this.sendDeletedQuery.emit(this.deletedQuery);
      }
    });
  }


  // Toggles the edit mode for a specific block
  toggleEdit(block: any, e: any) {
    block.isEditing = !block.isEditing;
    setTimeout(() => {
      this.adjustHeight(document.getElementById('txtarea' + block.nlpTemplateID) as HTMLTextAreaElement);
    }, 200);
  }

  // Save the updated text for a specific block
  saveText(block: any, updatedText: string) {
    block.apiResponseTextArea = updatedText;
    block.isEditing = false;
    this.addFileAIPrompts(0, block);
  }

  // Adjust textarea height dynamically
  adjustHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto'; // Reset height
    textarea.style.height = textarea.scrollHeight + 'px'; // Set to scroll height
  }
  trackByFn(index: number, item: any): number {
    return item.systemPromptID; // Use unique identifier
  }

  selectSysPrompt(event) {
    this.ddlsystemPromptID = Number(event.value);
    if (!this.formDialog.controls['title'].value || this.formDialog.controls['title'].value.trim() === '') {
      var check = [];
      check = this.sysPromptList.filter(x => x.systemPromptID == Number(event.value));
      if (check.length > 0) {
        this.formDialog.controls['title'].setValue(check[0].systemPromptTitle);
      }
    }
    this.formDialog.markAsDirty();
  }

  addFileAIPrompts(index: number, block: any) {
    if (block.askQAquery == "" && !(block.systemPromptID > 0)) {
      this.toastr.warning('Please add question or select a Predefined Model.', '', {
        timeOut: 3000,
      });
      return;
    }
    var ReqModel = {
      documentID: this.documentsId,
      promptID: block.nlpTemplateID,//this.queryBlocks[index].nlpTemplateID,
      prompt: block.askQAquery,//this.queryBlocks[index].askQAquery,
      reply: block.apiResponseTextArea,//this.queryBlocks[index].apiResponseTextArea,
      title: block.title,
      userID: this.currentUser.UID,
      isNta: block.isNta,
      position: block.position,
      isMedication: block.isMedication,
      isAllergy: block.isAllergy,
      isCondition: block.isCondition,
      isImmunization: block.isImmunization,
      isObservation: block.isObservation,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      choosenPromptID: block.choosenPromptID,
      systemPromptID: block.systemPromptID
    }
    this.formsService.addFileAIPrompt(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Question saved successfully.', '', {
            timeOut: 3000,
          });
          this.sendsaveUpdateQuery.emit(true);
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  close() {
    this.indexx = 0;
    this.dialog.closeAll();
  }

  askquestion: string = "";
  answer: string = "";
  indexx: number = 0;
  title: string = "";
  formDialog: FormGroup;
  nlpTemplateID: number = 0;
  position: number = 0;

  openQuestionPanel(templateRef: TemplateRef<any>, block: any, index: number) {
    this.position = block.position;
    this.currentBlockToEdit = block;
    this.indexx = index;
    this.nlpTemplateID = block.nlpTemplateID;
    this.currentAnswerChooseIndex = index;
    this.ddlsystemPromptID = block.systemPromptID == undefined ? 0 : block.systemPromptID;
    //this.askquestion=block.askQAquery;
    //this.answer=block.apiResponseTextArea;
    // this.title = block.title;
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('title', this.formBuilder.control(''));
    this.formDialog.addControl('prompt', this.formBuilder.control(''));
    this.formDialog.addControl('answer', this.formBuilder.control(''));
    this.formDialog.addControl('isNta', this.formBuilder.control(false));
    this.formDialog.addControl('isMedication', this.formBuilder.control(false));
    this.formDialog.addControl('isAllergy', this.formBuilder.control(false));
    this.formDialog.addControl('isCondition', this.formBuilder.control(false));
    this.formDialog.addControl('isImmunization', this.formBuilder.control(false));
    this.formDialog.addControl('isObservation', this.formBuilder.control(false));


    this.formDialog.controls['title'].setValue(block.title);
    this.formDialog.controls['prompt'].setValue(block.askQAquery);
    this.formDialog.controls['answer'].setValue(block.apiResponseTextArea);
    this.formDialog.controls['isNta'].setValue(block.isNta);
    this.formDialog.controls['isMedication'].setValue(block.isMedication);
    this.formDialog.controls['isAllergy'].setValue(block.isAllergy);
    this.formDialog.controls['isCondition'].setValue(block.isCondition);
    this.formDialog.controls['isImmunization'].setValue(block.isImmunization);
    this.formDialog.controls['isObservation'].setValue(block.isObservation);

    this.dialog.open(templateRef, {
      panelClass: 'addAiModalBox',
    });
  }

  updateQuestions(data) {
    if (data.title == "" || data.title == null) {
      this.toastr.warning('Please add title.', '', {
        timeOut: 3000,
      });
      return;
    }
    if ((data.prompt == '' || data.prompt == null) && this.ddlsystemPromptID == 0) {
      this.toastr.warning('Please add question or select a Predefined Model.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.queryBlocks.find(m => m.nlpTemplateID == this.nlpTemplateID).systemPromptID = this.ddlsystemPromptID;
    var ReqModel = {
      documentID: this.documentsId,
      promptID: this.nlpTemplateID,//this.queryBlocks[index].nlpTemplateID,
      prompt: data.prompt,//this.queryBlocks[index].askQAquery,
      reply: data.answer,//this.queryBlocks[index].apiResponseTextArea,
      title: data.title,
      isNta: data.isNta,
      isMedication: data.isMedication,
      isAllergy: data.isAllergy,
      isCondition: data.isCondition,
      isImmunization: data.isImmunization,
      isObservation: data.isObservation,
      position: this.position,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      ChoosenPromptID: this.queryBlocks.find(m => m.nlpTemplateID == this.nlpTemplateID).choosenPromptID,
      systemPromptID: this.queryBlocks.find(m => m.nlpTemplateID == this.nlpTemplateID).systemPromptID
    }
    this.loaderService.show();
    this.formsService.addFileAIPrompt(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.toastr.success('Question update successfully.', '', {
            timeOut: 3000,
          });
          this.sendsaveUpdateQuery.emit(true);
          this.close();
        } else {
          this.close();
          this.loaderService.hide();
        }
      } else {
        this.close();
        this.loaderService.hide();
      }
    });

  }

  runAIButton(block) {
    if (block.prompt == "" || block.prompt == null) {
      this.toastr.warning('Please add prompt.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.openpanel = this.indexx;
    this.loaderService.show();
    this.formsService.query_vector_db(block.prompt, this.VectorDocumentID)
      .subscribe(
        response => {
          if (response.success) {
            this.loaderService.hide();
            this.formDialog.controls['answer'].setValue(response.response);
            this.formDialog.markAsDirty();
            //this.queryBlocks[this.indexx].apiResponseTextArea = response.response;  
          } else {
            this.loaderService.hide();
          }
        },
        error => {
          this.loaderService.hide();
        }
      );
  }


  AddVectorFileID(vectorFileID: any) {
    var ReqModel = {
      "docFrom": 4,
      "documentID": this.documentId,
      "vectorFileID": vectorFileID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    }
    this.formsService.AddVectorFileID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {

        } else {
        }
      } else {
      }
    });
  }

  processDocumentToVectorDBDialogue(block) {
    if (block.prompt == "" || block.prompt == null) {
      this.toastr.warning('Please add prompt.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (this.VectorDocumentID == "") {
      const userId = this.currentUser.UID;
      const officeId = this.myOfficeID;
      const organizationId = this.organizationId;
      this.loaderService.show();
      this.formsService.processDocument(this.pdfURL, userId, officeId, organizationId)
        .subscribe(
          response => {
            if (response.success) {
              this.toastr.success('Document processed successfully')
              this.VectorDocumentID = response.message;
              this.AddVectorFileID(response.message);
              this.loaderService.hide();
              this.runAIButton(block);
            } else {
              this.loaderService.hide();
            }
          },
          error => {
            this.loaderService.hide();
          }
        );
    }
    else {
      this.runAIButton(block);
    }
  }

  GetEmitTOSendMedication(transactionIDFromDetailPage: any) {
    this.transactionID = transactionIDFromDetailPage;

    let medBlock = this.queryBlocks.find(m => m.isMedication == true);
    let ObservationResp = this.queryBlocks.find(m => m.isObservation == true);
    let ImmunizationResp = this.queryBlocks.find(m => m.isImmunization == true);
    let ConditionResp = this.queryBlocks.find(m => m.isCondition == true);
    let AllergyResp = this.queryBlocks.find(m => m.isAllergy == true);

    // --- save medication separately ---
    if (medBlock != undefined) {
      if (medBlock.apiResponseTextArea && medBlock.apiResponseTextArea.trim() != "") {
        this.saveTextToCore(medBlock.apiResponseTextArea, medBlock.nlpTemplateID);
      }
    }

    // --- collect prompts (Observation, Immunization, Condition, Allergy) ---
    let payloads: any[] = [];

    if (ObservationResp && ObservationResp.apiResponseTextArea && ObservationResp.apiResponseTextArea.trim() != "") {
      payloads.push({
        promptID: ObservationResp.nlpTemplateID,
        jsonData: ObservationResp.apiResponseTextArea,
        promptType: "Observation"
      });
    }

    if (ImmunizationResp && ImmunizationResp.apiResponseTextArea && ImmunizationResp.apiResponseTextArea.trim() != "") {
      payloads.push({
        promptID: ImmunizationResp.nlpTemplateID,
        jsonData: ImmunizationResp.apiResponseTextArea,
        promptType: "Immunization"
      });
    }

    if (ConditionResp && ConditionResp.apiResponseTextArea && ConditionResp.apiResponseTextArea.trim() != "") {
      payloads.push({
        promptID: ConditionResp.nlpTemplateID,
        jsonData: ConditionResp.apiResponseTextArea,
        promptType: "Condition"
      });
    }

    if (AllergyResp && AllergyResp.apiResponseTextArea && AllergyResp.apiResponseTextArea.trim() != "") {
      payloads.push({
        promptID: AllergyResp.nlpTemplateID,
        jsonData: AllergyResp.apiResponseTextArea,
        promptType: "Allergy"
      });
    }

    // --- send prompts only if available ---
    if (payloads.length > 0) {
      this.sendPromptsToCore(payloads);
    }
  }

  sendPromptsToCore(payloads: any[]) {
    this.loaderService.show();

    // final request model
    var ReqModel = {
      transactionID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      prompts: payloads
    };

    // API call
    this.formsService.SendPromptsToCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();

        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          // mark all blocks as saved
          payloads.forEach(p => {
            let block = this.queryBlocks.find(m => m.nlpTemplateID == p.promptID);
            if (block) block.isSaved = true;
          });

          this.toastr.success('All prompts saved successfully.', '', { timeOut: 3000 });
        } else {
          this.toastr.error('Error Occurred', '', { timeOut: 3000 });
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  saveTextToCore(apiResponseTextArea, prompIdToSend) {
    this.loaderService.show();
    let prompt = `
    Convert the following medications data into a JSON array where each medication is an object.
    Values which are null or not there should be given as Not specified.
    Include fields like name, Schedule,ScheduleType, AlternateScheduleType( If provided in data), dosage,Dosage_UOM,frequency, route,start_date,end_date,status,IndicationsForUse.
    Return ONLY the JSON with no additional text or explanations.
    
    Given medications data :
    ${apiResponseTextArea}

    Example Output:
    [
  {
    "name": "Amlodipine",
    "Schedule": "Routine",
    "ScheduleType": "Everyday"
    "AlternateScheduleType":"If provided in data"
    "dosage": "10",
    "Dosage_UOM": "mg",
    "frequency": "one time a day",
    "route": "by_mouth" // Oral or IV
    "start_date": "10/5/2024",
    "end_date": "12/5/2024",
    "Status": "Current", // Current or discontinued
    "IndicationsForUse":"blood pressure"
  }
]
  `;
    this.sendMedicationToCore(prompt, prompIdToSend)


    //this.runAIButton_4o_onGivenContext(prompt)
  }

  // Not using Any more
  // Instead use submit_prompt_4o_onGivenContext_New as written in file  \src\app\applicationModules\core\services\coreService\core.service.ts
  runAIButton_4o_onGivenContext(prompt: any) {
    this.formsService.submit_prompt_4o_onGivenContext(prompt)
      .subscribe(
        response => {
          if (response.success) {
            this.loaderService.hide();
            response.response;
            // Extract JSON from AI's response (handling edge cases)

            //const jsonString = this.extractJSON(response.response);
            // this.sendMedicationToCore(response.response);
          } else {
            this.loaderService.hide();
          }
        },
        error => {
          this.loaderService.hide();
        }
      );
  }

  extractJSON(str) {
    // First try to parse the entire string as JSON
    try {
      const data = JSON.parse(str);
      if (Array.isArray(data)) {
        return data;
      }
    } catch (e) {
      // If that fails, look for JSON within the string
    }

    // Find the first opening bracket
    const start = str.indexOf('[');
    if (start === -1) {
      throw new Error("No JSON array found in string");
    }

    let braceCount = 1;
    let end = start + 1;

    // Find the matching closing bracket
    for (let i = start + 1; i < str.length; i++) {
      if (str[i] === '[') {
        braceCount++;
      } else if (str[i] === ']') {
        braceCount--;
        if (braceCount === 0) {
          end = i + 1;
          break;
        }
      }
    }

    if (braceCount !== 0) {
      throw new Error("Unbalanced brackets in JSON");
    }

    // Extract the JSON portion
    const jsonStr = str.slice(start, end);

    return jsonStr;
  }

  sendMedicationToCore(jsonDataFromAI: any, prompIdToSend: any) {
    this.loaderService.show();
    var ReqModel = {
      transactionID: this.transactionID,
      userID: this.currentUser.UID,
      jsonData: jsonDataFromAI,
      officeID: this.myOfficeID,
      promptID: prompIdToSend,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formsService.SendMedicationToCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.queryBlocks.find(m => m.nlpTemplateID == prompIdToSend).isMedicationSaved = true;
          this.toastr.success('Saved successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.toastr.error('Error Occurred', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  runAIButton_4o(block: any) {
    if (block.title == "" || block.title == null) {
      this.toastr.warning('Please add title.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.openpanel = this.indexx;;
    this.loaderService.show();
    //let currentblockId = (document.getElementById("nlpCurrentTemplateID") as HTMLInputElement).value;

    block.choosenPromptID = this.queryBlocks.find(k => k.nlpTemplateID == this.nlpTemplateID).choosenPromptID;
    if (block.choosenPromptID) {
      // Ensure choosenPromptID is handled as a comma-separated list
      const promptIDs = block.choosenPromptID.split(',').map(id => parseInt(id.trim(), 10));

      // Process each ID, even if there's only one
      promptIDs.forEach(promptID => {
        const matchingBlock = this.queryBlocks.find(m => m.nlpTemplateID === promptID);
        if (matchingBlock) {
          block.prompt = block.prompt + " " + matchingBlock.apiResponseTextArea;
        }
      });
    }

    this.formsService.submit_prompt_4o(this.pdfURL, block.prompt, block.isNta, block.isNta == true ? "Patient Document" : this.pdfTextFromOCR)
      .subscribe(
        response => {
          if (response.success) {
            this.loaderService.hide();
            this.formDialog.controls['answer'].setValue(response.response);
            this.formDialog.markAsDirty();
            //this.queryBlocks[this.indexx].apiResponseTextArea = response.response;  
          } else {
            this.loaderService.hide();
          }
        },
        error => {
          this.loaderService.hide();
        }
      );
  }

  chooseResponse(templateRef: TemplateRef<any>, block, index) {
    this.currentAnswerChooseIndex = index;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  OnChangeChooseAnswer(e, block, index) {
    this.formDialog.markAsDirty();
    if (e.checked) {
      this.queryBlocks[this.currentAnswerChooseIndex].choosenAnswer =
        this.queryBlocks[index].apiResponseTextArea;


      //
      if (!this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID) {
        // Initialize choosenPromptID if it's undefined or empty
        this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID = '';
      }

      // Get the new nlpTemplateID to append
      let nlpTemplateID = this.queryBlocks[index].nlpTemplateID.toString();

      // Get the current choosenPromptID value
      let currentValue = this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID;

      // Append the new value with a comma, ensuring no trailing commas
      this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID = currentValue
        ? currentValue + ',' + nlpTemplateID
        : nlpTemplateID;

      //
      // this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID =
      // this.queryBlocks[index].nlpTemplateID;
    } else {
      let nlpTemplateID = this.queryBlocks[index].nlpTemplateID.toString();

      // Remove the unchecked nlpTemplateID from choosenPromptID
      let currentValue = this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID;

      // Split by commas, filter out the unchecked nlpTemplateID, and join back
      this.queryBlocks[this.currentAnswerChooseIndex].choosenPromptID = currentValue
        .split(',')
        .filter(id => id !== nlpTemplateID)
        .join(',');
    }
  }

  getQueryList(result) {
    var ReqModel = {
      documentID: this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formsService.getFileAIPrompt(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.queryBlocks = [];
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          //  this.queryBlocks=[];
          if (this.responseHolder.data && this.responseHolder.data.prompts && this.responseHolder.data.prompts.length > 0) {
            this.queryBlocks = [];
            for (let i = 0; i < this.responseHolder.data.prompts.length; i++) {
              var text = this.responseHolder.data.prompts[i].isNta==true? this.formatNtaSummary(this.responseHolder.data.prompts[i].reply): this.formatApiResponse(this.responseHolder.data.prompts[i].reply);
              const obj = {
                nlpTemplateID: this.responseHolder.data.prompts[i].promptID,
                askQAquery: this.responseHolder.data.prompts[i].prompt,
                apiResponseTextArea: text,
                apiResponseTextAreaNew: (text || '').replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>'),
                // apiResponseTextAreaNew: this.responseHolder.data[i].reply
                //   .replace(/\n\n/g, '<br><br>')
                //   .replace(/\n/g, '<br>'),
                title: this.responseHolder.data.prompts[i].title,
                isNta: this.responseHolder.data.prompts[i].isNta,
                isMedication: this.responseHolder.data.prompts[i].isMedication,
                	isAllergy:this.responseHolder.data.prompts[i].isAllergy,
                  isCondition:this.responseHolder.data.prompts[i].isCondition,
                  isImmunization:this.responseHolder.data.prompts[i].isImmunization,
                  isObservation:this.responseHolder.data.prompts[i].isObservation,
                isMedicationSaved:this.responseHolder.data.prompts[i].isMedicationSaved,
                position: this.responseHolder.data.prompts[i].position,
                choosenAnswer: '',
                choosenPromptID: this.responseHolder.data.prompts[i].choosenPromptID,
                staticTitleForChoosenID: this.responseHolder.data.prompts[i].staticTitleForChoosenID,
                isEditing: false,
                systemPromptID: this.responseHolder.data.prompts[i].systemPromptID
              };
              this.queryBlocks.push(obj);
            }
          } else {
            //this.queryBlocks.push({nlpTemplateID:0, askQAquery: '', apiResponseTextArea: '' ,title:e.title,});
          }
        } else {
          this.queryBlocks = [];
          this.loaderService.hide();
        }
      } else {
        this.queryBlocks = [];
        this.loaderService.hide();
      }
    });
  }

formatApiResponse(responseText) {
    if (!responseText) {
        return "No data available";
    }

    const trimmedText = responseText.trim();
    let jsonData;

    // Attempt to parse JSON only if it looks like JSON
    if ((trimmedText.startsWith("{") && trimmedText.endsWith("}")) ||
        (trimmedText.startsWith("[") && trimmedText.endsWith("]"))) {
        try {
            jsonData = JSON.parse(trimmedText);
        } catch (e) {
            // Invalid JSON, return as plain text
            return responseText;
        }
    } else {
        // Not JSON, return as plain text
        return responseText;
    }

    // If parsed JSON is an array with items
    if (Array.isArray(jsonData) && jsonData.length > 0) {
        const firstItem = jsonData[0];

        // Allergy array or outliers
        if (firstItem.allergy || firstItem.outliers) {
            return this.formatAllergies(jsonData);
        }


        // Immunization array
        if (firstItem.immunization) {
            return this.formatImmunizations(jsonData);
        }

        // Condition array
        if (firstItem.identifier?.coding) {
            return this.formatConditions(jsonData);
        }

        // Observation array
        if (firstItem.observation || firstItem.category) {
            return this.formatObservations(jsonData);
        }
    }

    // JSON parsed but doesn't match known patterns → return formatted JSON string
    return responseText;
}

// Your existing formatting functions (slightly modified for consistency)
 formatAllergies(allergiesJson) {
    if (!Array.isArray(allergiesJson)) return "Invalid allergies data";
    if (allergiesJson.length === 0) return "No allergies recorded";
      if (allergiesJson.some(item => item.outliers)) {
    return "No Allergies information is available in the provided document.";
  }
    return allergiesJson.map((item, index) => {
        const allergy = item.allergy;
        if (!allergy) return `${index + 1}. Invalid allergies data`;


        const lines = [
            `${index + 1}. ${allergy.allergen?.display || 'Unknown allergen'}`,
            `   Category: ${allergy.category || 'Unknown'}`,
            `   Type: ${allergy.type || 'Unknown'}`,
            `   Status: ${allergy.clinicalStatus || 'Unknown'}`,
            `   Severity: ${allergy.severity || 'Unknown'}`
        ];

        if (allergy.onsetDate) lines.push(`   Onset Date: ${allergy.onsetDate}`);
        if (allergy.reactionType) {
            let reactionLine = `   Reaction: ${allergy.reactionType}`;
            if (allergy.reactionSubType) reactionLine += ` (${allergy.reactionSubType})`;
            lines.push(reactionLine);
        }
        if (allergy.reactionNote) lines.push(`   Notes: ${allergy.reactionNote}`);

        return lines.join('\n');
    }).join('\n\n');
}

 formatImmunizations(immunizationsJson) {
    if (!Array.isArray(immunizationsJson)) return "Invalid immunizations data";
    if (immunizationsJson.length === 0) return "No immunizations recorded";

    return immunizationsJson.map((item, index) => {
        const immunization = item.immunization;
        if (!immunization) return `${index + 1}. Invalid immunization data`;

        const vaccineName = immunization.immunizationProduct?.coding?.[0]?.display || 'Unknown vaccine';
        const adminDate = immunization.administrationDateTime ? 
            new Date(immunization.administrationDateTime).toLocaleDateString() : 'Unknown date';
        
        const lines = [
            `${index + 1}. ${vaccineName}`,
            `   Administered: ${adminDate}`
        ];

        if (immunization.notes) lines.push(`   Status: ${immunization.notes}`);

        return lines.join('\n');
    }).join('\n\n');
}

 formatConditions(conditionsJson) {
    if (!Array.isArray(conditionsJson)) return "Invalid conditions data";
    if (conditionsJson.length === 0) return "No conditions recorded";

    return conditionsJson.map((item, index) => {
        const conditionName = item.identifier?.coding?.[0]?.display || 'Unknown condition';
        const onsetDate = item.onsetDate ? new Date(item.onsetDate).toLocaleDateString() : 'Unknown onset';
        
        const lines = [
            `${index + 1}. ${conditionName}`,
            `   Status: ${item.clinicalStatus || 'Unknown'}`,
            `   Type: ${item.rank || 'Unknown'}`
        ];

        if (item.onsetDate) lines.push(`   Onset: ${onsetDate}`);
        if (item.additionalInformation) lines.push(`   Details: ${item.additionalInformation}`);

        return lines.join('\n');
    }).join('\n\n');
}

 formatObservations(observationsJson) {
    if (!Array.isArray(observationsJson)) return "Invalid observations data";
    if (observationsJson.length === 0) return "No observations recorded";

    let formattedText = '';
    
    observationsJson.forEach((item, index) => {
        if (item.observation && Array.isArray(item.observation)) {
            if (index > 0) formattedText += '\n\n';
            
            formattedText += `Observation Set ${index + 1}:\n`;
            
            const observationText = item.observation.map((obs, obsIndex) => {
                const observationName = obs.identifier?.coding?.[0]?.display || 'Unknown observation';
                const obsDate = obs.effectiveDateTime ? 
                    new Date(obs.effectiveDateTime).toLocaleDateString() : 'Unknown date';
                
                const lines = [
                    `  ${obsIndex + 1}. ${observationName}`,
                    `     Value: ${obs.value || 'N/A'}${obs.unit ? ` ${obs.unit}` : ''}`,
                    `     Date: ${obsDate}`
                ];

                if (obs.interpretation) lines.push(`     Interpretation: ${obs.interpretation}`);
                if (obs.category) lines.push(`     Category: ${obs.category}`);
                if (obs.method?.coding?.[0]?.display) lines.push(`     Method: ${obs.method.coding[0].display}`);

                return lines.join('\n');
            }).join('\n\n');

            formattedText += observationText;
        } else if (item.category) {
            // Handle single observation objects
            if (index > 0) formattedText += '\n\n';
            
            const observationName = item.identifier?.coding?.[0]?.display || 'Unknown observation';
            const obsDate = item.effectiveDateTime ? 
                new Date(item.effectiveDateTime).toLocaleDateString() : 'Unknown date';
            
            const lines = [
                `${index + 1}. ${observationName}`,
                `   Value: ${item.value || 'N/A'}${item.unit ? ` ${item.unit}` : ''}`,
                `   Date: ${obsDate}`
            ];

            if (item.interpretation) lines.push(`   Interpretation: ${item.interpretation}`);
            if (item.category) lines.push(`   Category: ${item.category}`);
            if (item.method?.coding?.[0]?.display) lines.push(`   Method: ${item.method.coding[0].display}`);

            formattedText += lines.join('\n');
        }
    });

    return formattedText || "No valid observations found";
}

formatNtaSummary(jsonString) {
  try {
    // Attempt to parse the string into a JavaScript object.
    const data = JSON.parse(jsonString);

    // Check for the mandatory keys to ensure it has the correct structure.
    if (!data.summary || !Array.isArray(data.ntaSummary)) {
      throw new Error("Invalid JSON structure");
    }

    // --- Start building the human-readable text ---
    let formattedText = "PDPM NTA Opportunity Summary\n";
    formattedText += "=============================\n\n";

    // Format the main summary section
    const summary = data.summary;
    formattedText += `Overall Summary:\n`;
    formattedText += `  - NTA Points: ${summary.ntaPoints}\n`;
    formattedText += `  - NTA CMG: ${summary.ntaCmg}\n`;
    formattedText += `  - HIPPS Character: ${summary.hippsCharacter}\n`;
    formattedText += `  - NTA CMI: ${summary.ntaCmi}\n`;
    formattedText += `  - Step-Up Potential: ${summary.stepUpPotential}\n`;
    formattedText += `  - Over-Coding Risk: ${summary.overCodingRisk}\n`;
    formattedText += `  - Optimization Score: ${summary.optimizationScore}\n`;
    formattedText += `  - Payer: ${summary.payer}\n\n`;

    formattedText += "Detailed NTA Conditions:\n";
    formattedText += "------------------------\n\n";

    // Loop through each item in the ntaSummary array and format it
    data.ntaSummary.forEach((item, index) => {
      formattedText += `Item ${index + 1}: ${item.diagnosis || item.ntaCondition}\n`;
      formattedText += `  - Status: ${item.status}\n`;
      if (item.icd10) {
        formattedText += `  - ICD-10 Code: ${item.icd10}\n`;
      }
      if (item.proposed) {
        formattedText += `  - Proposed ICD-10: ${item.proposed}\n`;
      }
      formattedText += `  - NTA Points: ${item.points}\n`;
      if (item.potential) {
        formattedText += `  - Potential Points: ${item.potential}\n`;
      }
      if (item.risk) {
        formattedText += `  - Risk: ${item.risk}\n`;
      }
      formattedText += `\n  - Description: ${item.detailedDescription}\n`;
      formattedText += `  - Evidence Location: ${item.location_in_patient_Document}\n`;
      if (item.step_Up_Reason) {
        formattedText += `  - Step-Up Rationale: ${item.step_Up_Reason}\n`;
      }
      if (item.needed_To_Qualify) {
        formattedText += `  - Action Required: ${item.needed_To_Qualify}\n`;
      }
      formattedText += "\n";
    });

    return formattedText;

  } catch (error) {
    // If parsing fails or the structure is wrong, return the original text.
    return jsonString;
  }
}

  runAIButton_4o_Run(index: number, block: any) {
    if (this.ocrTextFileUrl == "") {
      if (block.title == "" || block.title == null) {
        this.toastr.warning('Please add title.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.openpanel = index;
      this.loaderService.show();
      // if(block.choosenPromptID)
      // {
      //   //apiResponseTextArea
      //   //block.askQAquery= block.choosenAnswer+ block.askQAquery;

      //   block.askQAquery=this.queryBlocks.find(m=>m.nlpTemplateID==block.choosenPromptID).apiResponseTextArea + " "+ block.askQAquery    

      // }

      let newAskQAquery = "";
      if (block.choosenPromptID) {
        // Ensure choosenPromptID is handled as a comma-separated list
        const promptIDs = block.choosenPromptID.split(',').map(id => parseInt(id.trim(), 10));

        // Process each ID, even if there's only one

        promptIDs.forEach(promptID => {
          const matchingBlock = this.queryBlocks.find(m => m.nlpTemplateID === promptID);
          if (matchingBlock) {
            if (newAskQAquery == "")
              newAskQAquery = block.askQAquery + " " + matchingBlock.apiResponseTextArea;
            else
              newAskQAquery = newAskQAquery + " " + matchingBlock.apiResponseTextArea;
          }
        });
      }
      else {
        newAskQAquery = block.askQAquery;
      }

      if (block.systemPromptID > 0) {
        newAskQAquery = newAskQAquery + " " + this.sysPromptList.find(m => m.systemPromptID == block.systemPromptID).systemPrompt;
      }

      this.formsService.submit_prompt_4o(this.pdfURL, newAskQAquery, block.isNta, block.isNta == true ? "Patient Document" : this.pdfTextFromOCR)
        .subscribe(
          response => {
            if (response.success) {
              this.loaderService.hide();

              //  if(block.isMedication==true)
              //  {
              //  let processedText= this.processMedicationData(response.response);
              //  block.apiResponseTextArea=processedText.humanReadableText
              //  this.queryBlocks[index].apiResponseTextArea = processedText.humanReadableText; 
              //  }
              //  else
              //  {
              block.apiResponseTextArea = response.response
              this.queryBlocks[index].apiResponseTextArea = response.response;
              //  }

              this.addFileAIPrompts(0, block);
              //this.getQueryList("");
              //this.queryBlocks[index].apiResponseTextAreaNew = response.response; 
            } else {
              this.loaderService.hide();
              //console.error('Error querying vector DB', response.message);
            }
          },
          error => {
            this.loaderService.hide();
            //console.error('Error querying vector DB', error.message);
          }
        );
    }

    if (this.ocrTextFileUrl != "") {
      if (block.title == "" || block.title == null) {
        this.toastr.warning('Please add title.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.openpanel = index;
      this.loaderService.show();

      let newAskQAquery = "";
      if (block.choosenPromptID) {
        // Ensure choosenPromptID is handled as a comma-separated list
        const promptIDs = block.choosenPromptID.split(',').map(id => parseInt(id.trim(), 10));
        // Process each ID, even if there's only one        
        promptIDs.forEach(promptID => {
          const matchingBlock = this.queryBlocks.find(m => m.nlpTemplateID === promptID);
          if (matchingBlock) {
            if (newAskQAquery == "")
              newAskQAquery = block.askQAquery + " " + matchingBlock.apiResponseTextArea;
            else
              newAskQAquery = newAskQAquery + " " + matchingBlock.apiResponseTextArea;
          }
        });
      }
      else {
        newAskQAquery = block.askQAquery;
      }
      if (block.systemPromptID > 0) {
        newAskQAquery = newAskQAquery + " " + this.sysPromptList.find(m => m.systemPromptID == block.systemPromptID).systemPrompt;
      }
      this.formsService.new_submit_prompt_4o(this.ocrTextFileUrl, newAskQAquery, block.isNta).subscribe(response => {
        if (response.success) {
          this.loaderService.hide();
          //this.queryBlocks[index].apiResponseTextArea = response.response; 
          // if(block.isMedication==true)
          // {
          // let processedText= this.processMedicationData(response.response);
          // block.apiResponseTextArea=processedText.humanReadableText
          // this.queryBlocks[index].apiResponseTextArea = processedText.humanReadableText; 
          // }
          // else
          // {
          block.apiResponseTextArea = response.response
          this.queryBlocks[index].apiResponseTextArea = response.response;
          // }
          this.addFileAIPrompts(0, block);
        } else {
          this.loaderService.hide();
        }
      },
        error => {
          this.loaderService.hide();
        }
      );
    }
  }

  runAIButton_4o_Run_Gemini(index: number, block: any, isAllprompt: boolean = false) {
    if (this.ocrTextFileUrl == "") {
      if (block && (block.title == "" || block.title == null)) {
        this.toastr.warning('Please add title.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    const nlpTemplateIDs = this.queryBlocks
      .filter(block =>
        block.apiResponseTextArea === null ||
        block.apiResponseTextArea === undefined ||
        block.apiResponseTextArea === "" ||
        block.apiResponseTextArea.trim() === ""
      )
      .map(block => block.nlpTemplateID);

    if (isAllprompt && nlpTemplateIDs && nlpTemplateIDs.length == 0) {
      this.toastr.warning('All questions are already answered.', '', {
        timeOut: 3000,
      });
      return;
    }

    let requestModel = {
      "ocrTextFileUrl": this.ocrTextFileUrl,
      "promptIds": isAllprompt == true ? nlpTemplateIDs : [
        block.nlpTemplateID
      ],
      "fileID": this.documentId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.formsService.runAIButton_4o_Run_Gemini(requestModel).subscribe(response => {
      this.responseHolder = response;
      //this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess) {

        //block.apiResponseTextArea=response.response
        //this.queryBlocks[index].apiResponseTextArea = this.responseHolder.data.response; 

        //this.addFileAIPrompts(0,block);     
        this.getQueryList("")
      } else {
        this.loaderService.hide();
      }
    },
      error => {
        this.loaderService.hide();
      }
    );
  }

  processMedicationData(jsonString) {
    // 1. Clean and parse the JSON string
    const cleanedString = jsonString.replace(/^```json\s*/, '').replace(/\s*```$/, '');
    let jsonObj;

    try {
      jsonObj = JSON.parse(cleanedString);
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return { error: 'Invalid JSON format' };
    }

    // 2. Generate human-readable output
    let humanReadable = '';

    jsonObj.forEach((med, index) => {
      humanReadable += `Medication #${index + 1}\n`;
      humanReadable += `------------------------\n`;

      // Medication Info
      humanReadable += `* Name: ${med.medicationInfo.Medication_Name}\n`;
      humanReadable += `* Type: ${med.medicationInfo.Medication_Type}\n`;
      humanReadable += `* Dosage: ${med.medicationInfo.Medication_Dosage}\n`;
      humanReadable += `* Frequency: ${med.medicationInfo.Medication_Frequency}\n`;
      humanReadable += `* Route: ${med.medicationInfo.MedicationaAministrationRoute}\n`;
      humanReadable += `* Start Date: ${med.medicationInfo.Medication_Start_Date || 'Not specified'}\n`;
      humanReadable += `* End Date: ${med.medicationInfo.Medication_End_Date || 'Not specified'}\n\n`;

      // Prescriber Info
      if (med.prescriberInfo) {
        humanReadable += `Prescriber:\n`;
        humanReadable += `- ID: ${med.prescriberInfo.prescriberId}\n`;
        humanReadable += `- System: ${med.prescriberInfo.prescriberCodeSystem}\n\n`;
      }

      // Order Context
      if (med.orderContext) {
        humanReadable += `Order Details:\n`;
        humanReadable += `- Care Period ID: ${med.orderContext.carePeriodId}\n`;
        humanReadable += `- DD ID: ${med.orderContext.ddId}\n`;
        humanReadable += `- PN ID: ${med.orderContext.pnId}\n`;
        humanReadable += `- Discharge Summary: ${med.orderContext.isDischargeSummary ? 'Yes' : 'No'}\n\n`;
      }

      // Schedules
      if (med.schedules && med.schedules.length > 0) {
        humanReadable += `Administration Schedules:\n`;
        med.schedules.forEach((schedule, i) => {
          humanReadable += `${i + 1}. ${schedule.schedule} Schedule\n`;
          humanReadable += `   - Dose: ${schedule.dose} ${schedule.doseUOM || ''}\n`;
          if (schedule.frequency) humanReadable += `   - Frequency: ${schedule.frequency}\n`;
          if (schedule.diagnosisLinked) humanReadable += `   - Linked Diagnosis: ${schedule.diagnosisLinked}\n`;
          if (schedule.indication) humanReadable += `   - Indication: ${schedule.indication}\n`;
          if (schedule.prnTiming) humanReadable += `   - PRN Timing: Every ${schedule.prnTimingValue} ${schedule.prnTiming}\n`;
        });
      }

      humanReadable += '\n\n';
    });

    return {
      jsonObject: jsonObj,
      humanReadableText: humanReadable
    };
  }

  onCheckboxChange(selectedControl: string) {

    const controls = [
      'isNta',
      'isMedication',
      'isAllergy',
      'isImmunization',
      'isCondition',
      'isObservation'
    ];
    controls.forEach(control => {
      if (control === selectedControl) {
        this.formDialog.get(control)?.setValue(true, { emitEvent: false });
      } else {
        this.formDialog.get(control)?.setValue(false, { emitEvent: false });
      }
    });
  }


  SendDocumentTo_4o(block) {
    if (block.prompt == "" || block.prompt == null) {
      this.toastr.warning('Please add prompt.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.runAIButton_4o(block);

  }

  togglePanels(index: number) {
    //sessionStorage.setItem('currentCoreTabIndex', `${index}`);
    this.step = index;
  }


  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.queryBlocks, event.previousIndex, event.currentIndex);
    var record: any = [] = [];
    var reOrdersList: any = [] = [];
    record = this.queryBlocks;
    if (record.length > 0) {
      reOrdersList = [];
      for (let i = 0; i < record.length; i++) {
        var obj = {
          promptID: record[i].nlpTemplateID,
          position: i + 1
        }
        reOrdersList.push(obj);
      }

      var reqModel = {
        documentID: this.documentId,
        prompts: reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.formsService.reorderFileAIPrompt(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.step = 0;
            this.sendsaveUpdateQuery.emit(true);
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  getLinkedText(text: string): string {
    if (!text) {
      return ''; // Return an empty string if the input is null or undefined
    }
    // Match and replace page numbers
    return text.replace(/\[p\.(\d+)]/g, (match, pageNum) => {
      return `<a href="javascript:void(0)" onclick="goToPage(${pageNum})">p.${pageNum}</a>`;
    });
  }

  handleLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      const pageText = (target as HTMLAnchorElement).innerText;
      const splitText = pageText.split('.');
      var pageNumbers = Number(splitText[1]);
      this.sendPageNumber.emit(pageNumbers);
    }
  }

}
